import { PermissionRoles, Permissions } from './models';

export enum USER_STATUS {
  invited = 'INVITED',
  expired = 'EXPIRED',
  active = 'ACTIVE',
  deactivated = 'DEACTIVATED',
}

export enum USER_ROLES {
  accessManager = 'Access Manager',
  adAccountAdmin = 'Ad Account Admin',
  adAccountAnalyst = 'Ad Account Analyst',
  analyst = 'Analyst',
  buyer = 'Buyer',
  creativeManager = 'Creative Manager',
  creativeReviewer = 'Creative Reviewer',
  draxAdmin = 'Drax Admin',
  draxOpsManager = 'Drax Ops Manager',
  mcInventoryManager = 'Mc Inventory Manager',
  member = 'Member',
  orgAdmin = 'Organization Admin',
  planner = 'Planner',
  pricingManager = 'Pricing Manager',
  seller = 'Seller',
  spReviewer = 'Sp Reviewer',
  supportAdmin = 'Support Admin',
  supportEngineer = 'Support Engineer',
  trafficker = 'Trafficker',
}

export const INITIAL_PERMISSIONS: Permissions = {
  create: false,
  read: false,
  update: false,
  delete: false,
};

export const INITIAL_PERMISSIONS_ROLES: PermissionRoles = {
  createRoles: [],
  readRoles: [],
  updateRoles: [],
  deleteRoles: [],
};
